import { useInitData } from "@vkruglikov/react-telegram-web-app";
import type { PropsWithChildren } from "react";
import { useSearchParams } from "react-router-dom";

import { Spinner } from "@/ui/spinner";

import { useLoginByInitData } from "@/api/entities/user";

import { DEFAULT } from "@/shared/constants/default";

export function ProtectedRoute({ children }: PropsWithChildren) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_initDataUnsafe, initData] = useInitData();
  const [searchParams] = useSearchParams();
  const refCode = searchParams.get(DEFAULT.SEARCH_REF_CODE) || undefined;
  console.log("initData", initData);
  const { isLoading } = useLoginByInitData(initData, refCode);

  if (isLoading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return children;
}
